import { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "./pages/pages.css";
import { gapi } from 'gapi-script';
import { initClient } from './googleAuth'; // Ensure this is the correct path to your googleAuth.js

const localizer = momentLocalizer(moment);

const CLIENT_ID = '634638841312-kpbmltfee45bsvke7ss8qndlp5i9em4e.apps.googleusercontent.com';
const API_KEY = 'AIzaSyCywKDWd0WyAuG_dPfB5FUyfN5mnVkLnw4';

const CalendarSetup = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    initClient(CLIENT_ID, API_KEY).then(() => {
      const authInstance = gapi.auth2.getAuthInstance();
      if (authInstance.isSignedIn.get()) {
        fetchEvents();
      } else {
        authInstance.signIn().then(fetchEvents);
      }
    }).catch(error => {
      console.error('Error initializing Google API client:', error);
    });
  }, []);

  const fetchEvents = () => {
    gapi.client.calendar.events.list({
      calendarId: 'primary',
      timeMin: new Date().toISOString(),
      showDeleted: false,
      singleEvents: true,
      maxResults: 20,
      orderBy: 'startTime',
    }).then(response => {
      const events = response.result.items.map(event => ({
        id: event.id,
        title: event.summary,
        messages: event.description,
        start: new Date(event.start.dateTime || event.start.date),
        end:  new Date(event.start.dateTime || event.start.date)
      }));
      setEvents(events);
      console.log('jcTest:', response);
    }).catch(error => {
      console.error('Error fetching events:', error);
    });
  };
  const EventComponent = ({ event }) => (
    
      event.messages
   
  );

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        className='calendar'
        views={['month', 'week', 'day', 'agenda']}
        components={{
          time: EventComponent,
        }}
        style={{ height: 600, paddingTop: '100px' }}
      />
    </div>
  );
};

export default CalendarSetup;
